import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule } from '@angular/forms';
import { DcAlertModule } from '@datachain/ui-sdk/components/alert';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcOverlayBadgeModule } from '@datachain/ui-sdk/components/app-overlay-badge';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcPopoverModule } from '@datachain/ui-sdk/components/app-popover';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcArrayPipeModule } from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
	DxDataGridModule,
	DxSelectBoxModule,
	DxTemplateModule,
} from 'devextreme-angular';
import {
	DxiColumnModule,
	DxoColumnChooserModule,
	DxoColumnFixingModule,
	DxoFilterPanelModule,
	DxoFilterRowModule,
	DxoGroupPanelModule,
	DxoHeaderFilterModule,
	DxoLoadPanelModule,
	DxoPagingModule,
	DxoSelectionModule,
	DxoSortingModule,
	DxoStateStoringModule,
} from 'devextreme-angular/ui/nested';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { OrphanProjectActionPopupComponent } from './components/orphan-project-action-popup/orphan-project-action-popup.component';
import { OrphanProjectListComponent } from './components/orphan-project-list/orphan-project-list.component';
import { OrphanProjectParser } from './orphan-project-parser';
import { OrphanProjectEffects } from './store/orphan-project.effects';
import { orphanProjectReducer } from './store/orphan-project.reducer';
import { OrphanProjectSelector } from './store/orphan-project.selector';
import { OrphanProjectState } from './store/orphan-project.state';

@NgModule({
	declarations: [OrphanProjectListComponent, OrphanProjectActionPopupComponent],
	imports: [
		CommonModule,
		UiModule,
		DcPageModule,
		MaterialModule,
		StoreModule.forFeature(OrphanProjectState.key, orphanProjectReducer),
		EffectsModule.forFeature([OrphanProjectEffects]),
		FormsModule,
		DcArrayPipeModule,
		DcAvatarModule,
		DcBadgeModule,
		DcOverlayBadgeModule,
		DcPanelModule,
		DcPopoverModule,
		DcAlertModule,
		DxDataGridModule,
		DxTemplateModule,
		DxiColumnModule,
		DxoColumnChooserModule,
		DxoColumnFixingModule,
		DxoFilterPanelModule,
		DxoFilterRowModule,
		DxoGroupPanelModule,
		DxoHeaderFilterModule,
		DxoLoadPanelModule,
		DxoPagingModule,
		DxoSelectionModule,
		DxoSortingModule,
		DxoStateStoringModule,
		DxSelectBoxModule,
	],
	providers: [OrphanProjectSelector, OrphanProjectParser],
})
export class OrphanProjectModule {
	public constructor(private readonly injector: Injector) {
		const orphanProjectsListCmpElement = createCustomElement(
			OrphanProjectListComponent,
			{
				injector,
			}
		);
		customElements.define(
			'app-orphan-project-list',
			orphanProjectsListCmpElement
		);
	}
}
